import $ from 'jquery';
import 'slick-carousel';

const initTabs = () =>   {

  let tabTriggers = document.querySelectorAll('.tabTrigger');
  let tabContents = document.querySelectorAll('.tabbed-area__container');

  Array.prototype.forEach.call(tabTriggers, (trigger) => {

    trigger.addEventListener('click', (e) => {

      e.preventDefault();

      document.querySelector('.tabbed-area__headingIcon--active').classList.remove('tabbed-area__headingIcon--active');
      //document.querySelector('.tabbed-area__container--active').classList.remove('tabbed-area__container--active');
      $(tabContents).fadeOut(150);

      let clickedTabNumber = trigger.attributes.tabnumber.value;

      trigger.classList.add('tabbed-area__headingIcon--active');


      Array.prototype.forEach.call(tabContents, (tab) => {

        let tabNumber = tab.attributes.tabnumber.value;

        if (clickedTabNumber === tabNumber){
          //tab.classList.add('tabbed-area__container--active');
          $(tab).find(".slider").slick("refresh");
          $(tab).fadeIn(500);
        }

      })

    });

  });

}


function Tabs () {
  initTabs();
}

export default Tabs;